import en from './en';
import es from './es';
import fr from './fr';
import kk from './kk';
import nl from './nl';
import pt from './pt';
import ru from './ru';

export { en, es, fr, kk, nl, pt, ru };
